export function formatInt(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return n.toLocaleString("en-US");
}

export function formatSignedInt(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  if (n > 0) return `+${formatInt(n)}`;
  return formatInt(n);
}

export function formatPct(p: number | null | undefined): string {
  if (p === null || p === undefined) return "—";
  if (p > 0) return `+${p.toFixed(1)}%`;
  return `${p.toFixed(1)}%`;
}

export function deltaColor(n: number): string {
  if (n > 0) return "#1b5e20"; // green
  if (n < 0) return "#7f1d1d"; // red
  return "#374151"; // neutral
}

export function deltaBg(n: number, magnitude: number): string {
  // magnitude is the largest abs delta in the dataset; used for opacity scaling
  const abs = Math.abs(n);
  const pct = magnitude > 0 ? Math.min(abs / magnitude, 1) : 0;
  if (n > 0) return `rgba(46, 125, 50, ${0.10 + pct * 0.55})`;
  if (n < 0) return `rgba(211, 47, 47, ${0.10 + pct * 0.55})`;
  return "rgba(0,0,0,0.04)";
}
